import {
  Button,
  Divider,
  Flex,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import LoadingPage from "@components/Loader/LoadingPage";
import { NFTEventInfo } from "@models/event";
import { DEFAULT_LANGUAGE } from "@models/language";
import { TransactionStatus } from "@models/payment";
import { ContactUsCard } from "@providers/checkout/Checkout/CheckoutSuccess/CheckoutSuccessCTA/CheckoutSuccessCTACards";
import type { NextPage } from "next";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";
import { AiOutlineWarning } from "react-icons/ai";
import { useUserStore } from "../../../auth";
import { backToEvent, cancelTransaction, usePaymentStore } from "../../payment";

const _t = (key?: string) => key || "";

const CheckoutCancel: NextPage = () => {
  const router = useRouter();
  const event = usePaymentStore((state) => state.event);
  const transaction = usePaymentStore((state) => state.transaction);
  const user = useUserStore((state) => state.user);
  const [handled, setHandled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log(transaction);
    if (!transaction || handled) return;
    setHandled(true);
    const cancel = async () => {
      if (transaction.status != TransactionStatus.SUCCEEDED)
        await cancelTransaction(transaction.id);
      setLoading(false);
    };
    cancel();
  }, [transaction, handled]);

  const info: NFTEventInfo = useMemo(() => {
    if (!event) return new NFTEventInfo({ name: "" });
    return event.localeInfo(DEFAULT_LANGUAGE);
  }, [event]);

  const retryTransaction = async () => {
    setLoading(true);
    return backToEvent();
  };

  useEffect(() => {
    if (!user || !event || !transaction) return;
    const cancel = async () => {
      if (transaction.status != TransactionStatus.SUCCEEDED)
        await cancelTransaction(transaction.id);
      setLoading(false);
    };

    if (transaction.userId !== user.id) {
      console.error("not transaction owner");
      backToEvent();
      return;
    } else {
      switch (transaction.status) {
        case TransactionStatus.SUCCEEDED: {
          router.push(
            `${window.location.pathname.replace("cancel", "success")}`
          );
          return;
        }
      }
      if (!handled) {
        setHandled(true);
        cancel();
      } else {
        setLoading(false);
      }
    }
  }, [event, transaction?.status, user, handled]);

  const titleTextColor = useColorModeValue("", "white");
  const subtitleTextColor = useColorModeValue("", "neutral.100");
  const dividerColor = useColorModeValue("neutral.300", "white");

  if (
    loading ||
    !user ||
    !event ||
    !transaction ||
    transaction.status == TransactionStatus.SUCCEEDED
  )
    return <LoadingPage />;
  return (
    <div className="flex-grow h-screen w-full relative -mt-28 p-8 pt-48">
      <div className="p-8 max-w-[30rem] mr-auto ml-auto">
        <Flex direction="column" align="center" justify="center">
          <Icon as={AiOutlineWarning} color="error" boxSize={12} />
          <Text
            mt={7}
            fontSize="2xl"
            fontWeight="medium"
            color={titleTextColor}
          >
            {_t("Checkout Failed")}
          </Text>
          <Text
            mt={3}
            fontSize="md"
            fontWeight="normal"
            color={subtitleTextColor}
            textAlign="center"
          >
            {_t("This checkout is canceled, please try again.")}
          </Text>

          {/* <a
          className="text-primary underline p-8"
          href={
            window.location.origin +
            window.location.pathname.replace(/\/checkout.+/, "/checkout")
          }
          target="_self"
        >
          {_t("Back to Checkout")}
        </a> */}

          <Button className="m-8" variant="outline" onClick={retryTransaction}>
            {_t("Try again")}
          </Button>

          <Flex align="center" mt={7} w="full" alignSelf="center">
            <Divider borderColor={dividerColor} />
            <Text
              padding="2"
              as={"span"}
              minW={"100px"}
              mx={4}
              textAlign="center"
              fontSize="md"
              fontWeight="medium"
              color={subtitleTextColor}
            >
              {_t("Need Help?")}
            </Text>
            <Divider borderColor={dividerColor} />
          </Flex>
          <div className="mt-9">
            <ContactUsCard />
          </div>
        </Flex>
      </div>
    </div>
  );
};
export default CheckoutCancel;
